// src/services/couponService.js

import axios from "axios";

const BASE_URL =
    process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
    const token =
        localStorage.getItem("authToken");

    return {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type":
                "application/json",
        },
    };
};

/* =========================
   FETCH COUPONS
========================= */
export const getCoupons = async () => {

    const response = await axios.get(
        `${BASE_URL}/promotions/api/admin/getall/coupons`,
        getAuthHeader()
    );

    return response.data;
};

/* =========================
   FETCH COMPANIES
========================= */
export const getCompanies = async () => {

    const response = await axios.get(
        `${BASE_URL}/subscription/api/admin/enquiries/getall`,
        getAuthHeader()
    );

    return response.data;
};

/* =========================
   CREATE COUPON
========================= */
export const createCoupon = async (
    payload
) => {

    const response = await axios.post(
        `${BASE_URL}/promotions/api/admin/create/coupon`,
        payload,
        getAuthHeader()
    );

    return response.data;
};